import React from "react";

import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";

import { toast } from "react-toastify";
import CourtAlertsApi from "../../api/courtAlertsApi";

class NotifyCourt extends React.Component {
  state = {
    courtId: "",
    date: "",
    time: "",
  };

  handleSubmit = (e) => {
    e.preventDefault();
  };

  handleNotify = async (r) => {
    const { courtId, date, time } = this.state;
    const { success, message } = await CourtAlertsApi.postNotifyCourt({ courtId, date, time });

    if (!success) {
      toast.error(message);
      return;
    }

    toast.success("Thanks for reporting the court");
    this.setState({ courtId: "", date: "", time: "" });
  };

  render() {
    const { courts, dates, times } = this.props.staticData;
    const { courtId, date, time } = this.state;

    return (
      <React.Fragment>
        <Container>
          <Row className="justify-content-md-center">
            <Col>
              <h1>Court Alerts - Notify Court</h1>
            </Col>
          </Row>
          <Row className="justify-content-flex-start">
            <Col>
              <form onSubmit={this.handleSubmit}>
                <div className="form-group mt-3">
                  <label htmlFor="court">Court:</label>
                  <select id="court" className="form-select" value={courtId} onChange={(e) => this.setState({ courtId: e.currentTarget.value })}>
                    <option key="empty" value="">
                      Select court
                    </option>
                    {Object.keys(courts).map((c) => (
                      <option key={c} value={c}>
                        {courts[c]}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group mt-3">
                  <label htmlFor="date">Date:</label>
                  <select id="date" className="form-select" value={date} onChange={(e) => this.setState({ date: e.currentTarget.value })}>
                    <option key="empty" value="">
                      Select date
                    </option>
                    {Object.keys(dates).map((d) => (
                      <option key={d} value={d}>
                        {dates[d]}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group mt-3">
                  <label htmlFor="time">Time:</label>
                  <select id="time" className="form-select" value={time} onChange={(e) => this.setState({ time: e.currentTarget.value })}>
                    <option key="empty" value="">
                      Select time
                    </option>
                    {Object.keys(times).map((t) => (
                      <option key={t} value={t}>
                        {times[t]}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-group mt-3">
                  <Button className="btn btn-primary btn-large" onClick={() => this.handleNotify()} disabled={!courtId || !date || !time}>
                    Notify
                  </Button>
                </div>
              </form>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default NotifyCourt;
